import { GoogleMapsAPIWrapper } from '@agm/core';
import { Directive, Input } from '@angular/core';
import { LoggerService } from '../../services';
import { OnDestroy } from '@angular/core';
import { TaggedLogger } from '../../services/taggedLogger';

@Directive({
  selector: 'agm-map-task-polyline',
})
export class TaskPolylineMapDirective implements OnDestroy {
  private logger: TaggedLogger;

  public _color: any;
  public _opacity: any;

  public _polyline: string;

  public directionsDisplays: Array<any>;
  public directionsPolylines: Array<any>;

  constructor(private gmapsApi: GoogleMapsAPIWrapper, loggerService: LoggerService) {
    this.directionsDisplays = [];
    this.directionsPolylines = [];
    this.logger = loggerService.taggedLogger('TaskPolylineMapDirective');
  }

  ngOnDestroy() {
    this.clearAllDirections();
    this.clearAllPolylines();
  }

  private clearAllDirections() {
    for (var j = this.directionsDisplays.length - 1; j >= 0; j--) {
      var directionsDisplay = this.directionsDisplays[j];

      directionsDisplay.setMap(null);

      this.directionsDisplays.splice(j, 1);
    }
  }

  private clearAllPolylines() {
    for (var j = this.directionsPolylines.length - 1; j >= 0; j--) {
      var directionsPolyline = this.directionsPolylines[j];

      directionsPolyline.setMap(null);

      this.directionsPolylines.splice(j, 1);
    }
  }

  @Input()
  set polyline(value: string) {
    this._polyline = value;

    this.updatePolyline();
  }

  get polyline(): string {
    return this._polyline;
  }

  @Input('color')
  set color(value: any) {
    this._color = value;

    this.updatePolyline();
  }
  get color() {
    return this._color;
  }

  @Input('opacity')
  set opacity(value: any) {
    this._opacity = value;

    this.updatePolyline();
  }
  get opacity() {
    return this._opacity;
  }

  updatePolyline() {
    this.logger.trace('Updating polyline');
    const that = this;

    this.clearAllDirections();

    this.gmapsApi.getNativeMap().then((map) => {
      that.clearAllPolylines();

      const colors = ['red', 'green', 'orange', 'yellow', 'black'];

      const decodedPath = google.maps.geometry.encoding.decodePath(that.polyline);
      const decodedLevels = that.decodeLevels('BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB');

      const setRegion = new (google.maps as any).Polyline({
        path: decodedPath,
        levels: decodedLevels,
        strokeColor: that.color ? that.color : colors[0 % 5],
        strokeWeight: 4,
        strokeOpacity: that.opacity ? that.opacity : 0.3,
        map: map,
      });

      that.directionsPolylines.push(setRegion);
    });
  }

  private decodeLevels(encodedLevelsString) {
    var decodedLevels = [];

    for (var i = 0; i < encodedLevelsString.length; ++i) {
      var level = encodedLevelsString.charCodeAt(i) - 63;
      decodedLevels.push(level);
    }
    return decodedLevels;
  }
}
